import { CorporateClients } from '@platform/client';
import { FormsInputDropdown, InputDropdownItem } from '@platform/components';
import { Control } from 'react-hook-form';

type CorporateClientSelectionDropdownProps = {
  selectionLimit?: number;
  // eslint-disable-next-line
  control: Control<any>;
  label: string;
};

export const CorporateClientSelectionDropdown = (props: CorporateClientSelectionDropdownProps) => {
  const { control, label } = props;

  const corporateClients = CorporateClients.useGetAllCorporateClients().data || [];

  const corporateClientOptions: InputDropdownItem[] = corporateClients.map((client) => ({
    textValue: client.name,
    text: client.name,
  }));

  return (
    <FormsInputDropdown
      control={control}
      name={'corporateClient'}
      label={label}
      placeholder='Select one'
      items={corporateClientOptions}
      type='default'
    />
  );
};
